import { generatePath } from "react-router-dom";
import config from "config";
import { useTranslation } from "locales";
import useBreakPoints from "hooks/useBreakPoints";
import useCustomDomain from "hooks/useCustomDomain";
import { BaseMenuItemInterface } from "types";
import { assetUrl } from "lib/assetUrl";
import useController from "./controller";
import { Routes } from "../../router/config";

function useViewController() {
  const {
    onClickMemberBalance,
    user,
    showGoLiveButton,
    showGoLiveModal,
    openGoLiveModal,
    closeGoLiveModal,
    unreadThreadsCount,
  } = useController();
  const { t } = useTranslation();
  const logoSrc = assetUrl("/images/logo.svg");

  const { mobileSMOnly: isMobileSM } = useBreakPoints();

  const { isCustomDomain } = useCustomDomain();

  const itemsList: BaseMenuItemInterface[] = [
    {
      name: "settings",
      icon: "settings",
      title: t("Settings"),
      to: "/user/settings",
      className: "__divider",
      divider: true,
    },
    {
      name: "logout",
      icon: "logout",
      title: t("Log out"),
      to: Routes.logout,
    },
  ];

  if (user?.role === config.userPerformerRole)
    itemsList.splice(0, 0, {
      name: "profile",
      icon: "profile",
      title: t("Profile"),
      to: isCustomDomain ? Routes.root : generatePath(Routes.rootByUsername, { username: user.username }),
    });

  return {
    logoSrc,
    itemsList,
    isMobileSM,
    onClickMemberBalance,
    user,
    showGoLiveButton,
    showGoLiveModal,
    openGoLiveModal,
    closeGoLiveModal,
    unreadThreadsCount,
  };
}

export default useViewController;
